import { render, staticRenderFns } from "./DialectsModal.vue?vue&type=template&id=6ba36816&scoped=true&"
import script from "./DialectsModal.vue?vue&type=script&lang=js&"
export * from "./DialectsModal.vue?vue&type=script&lang=js&"
import style0 from "./DialectsModal.vue?vue&type=style&index=0&id=6ba36816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba36816",
  null
  
)

export default component.exports